console.log('js/datalayer.js -> v0.1.0');

$(function() {
	window.dataLayer = window.dataLayer || [];
	$('.js-datalayer-click').click(function() { dataLayer.push(...$(this).closest('.js-datalayer').data('layer')) });
});
